// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__19Luf","search":"Settings_search__DppH8","filter":"Settings_filter__3CVLU"};